import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TextValidatorService {

  validateOnlyTextNumberSymbol(event: any): boolean {
    const pattern: RegExp = /[a-zA-ZÀ-ÿ\u00f1\u00d10-9@,-._ ]/;
    let inputChar: string = "";

    let clipboardData = event.clipboardData;
    inputChar = (clipboardData) ? clipboardData.getData('text') : String.fromCharCode(event.charCode);


    if (!pattern.test(inputChar)) {
        event.preventDefault();
        return false;
    }
    return true;
  }

  validateEmail(event: any): boolean {
    const emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let inputChar: string = "";
    let clipboardData = event.clipboardData;
    inputChar = (clipboardData) ? clipboardData.getData('text') : String.fromCharCode(event.charCode);
    if (!emailPattern.test(inputChar)) {
      event.preventDefault();
      return  false;
    }
    return true;
  }

  validateOnlyNumbers(event: any): boolean {
    let pattern = /^[0-9]*$/;

    let inputChar: string = "";
    let clipboardData = event.clipboardData;
    inputChar = (clipboardData) ? clipboardData.getData('text') : String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  validateNumberAndDecimals(event: any): boolean {
    let pattern = /^[0-9]*\.?[0-9]*$/;

    let inputChar: string = "";
    let clipboardData = event.clipboardData;
    inputChar = (clipboardData) ? clipboardData.getData('text') : String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }


  validateOnlyLetters(event: any, espacios: boolean = true): boolean {
    let pattern: RegExp;
    if(espacios)
      pattern = /^[a-zA-ZáéíñóúüÁÍÉÑÓÚÜ\s]*$/;
    else
      pattern = /^[a-zA-ZáéíñóúüÁÍÉÑÓÚÜ]*$/;

    let inputChar: string = "";
    let clipboardData = event.clipboardData;
    inputChar = (clipboardData) ? clipboardData.getData('text') : String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return  false;
    }
    return true;
  }

  validateOnlyLettersAndNumbers(event: any, espacios: boolean = true): boolean {
    let pattern: RegExp;

    if(espacios)
      pattern = /^[a-zA-ZáéíñóúüÁÍÉÑÓÚÜ0-9\s]*$/;
    else
      pattern = /^[a-zA-ZáéíñóúüÁÍÉÑÓÚÜ0-9]*$/;

    let inputChar: string = "";
    String.fromCharCode(event.charCode);
    let clipboardData = event.clipboardData;
    inputChar = (clipboardData) ? clipboardData.getData('text') :String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return  false;
    }
    return true;
  }

  validateLettersAndNumbersWithSpecialChars(event: any, espacios: boolean = true): boolean {
    let pattern: RegExp = /^[a-zA-Z0-9\s]*$/;
    let inputChar: string = "";
    String.fromCharCode(event.charCode);
    let clipboardData = event.clipboardData;
    inputChar = (clipboardData) ? clipboardData.getData('text') :String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return  false;
    }
    return true;
  }

  moveWithPoint(event: any): void {
    if (event.key === '.' || event.key === ',') {
      event.preventDefault();
      const inputElement = event.target as HTMLInputElement;
      const value = inputElement.value;
      const commaIndex = value.indexOf('.');
      if (commaIndex !== -1) {
        const zeroIndex = value.indexOf('.', commaIndex);
        if (zeroIndex !== -1) {
          const positionToMove = zeroIndex + 1 ;
          inputElement.focus();
          inputElement.setSelectionRange(positionToMove, positionToMove);
        }
      }
    }
  }

  soloNumeros(evt: KeyboardEvent): boolean {
    const code = evt.which ? evt.which : evt.keyCode;

    if (code === 8 || code === 46 || code === 44) {
      return true;
    }

    if (code >= 48 && code <= 57) {
      return true;
    }

    return false;
  }

  soloLetras(evt: KeyboardEvent): boolean {
    const key = evt.keyCode || evt.which;
    const tecla = String.fromCharCode(key).toLowerCase();
    const letras = " áéíóúabcdefghijklmnñopqrstuvwxyz";
    const especiales = [8, 37, 39, 46];

    if (especiales.includes(key)) {
      return true;
    }

    if (letras.indexOf(tecla) === -1) {
      return false;
    }

    return true;
  }

  soloLetrasYNumeros(evt: KeyboardEvent): boolean {
    const key = evt.keyCode || evt.which;
    const tecla = String.fromCharCode(key).toLowerCase();
    const letrasNumerosYEspacios = /^[a-zA-Z0-9\s]$/;
    const teclaEspecial = [8, 32, 37, 39, 46].includes(key);

    return (letrasNumerosYEspacios.test(tecla) || teclaEspecial) && tecla !== '%';
  }
}
